import gql from 'graphql-tag';
import { ProductAttributeAllData } from '../fragments';

export default gql`
query AdminProductAttributeListWithOptions {
    adminProductAttributes {
        ...ProductAttributeAllData
    }
}
${ProductAttributeAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProductAttributeListWithOptions.ts